import React, {useState} from 'react';
import { Button,  CardContent,  makeStyles, Dialog, DialogContent, DialogTitle, Grid, Hidden, Typography} from "@material-ui/core";
import { ApplicationUser } from '../../../entities/ApplicationUser';
import { AccountService } from '../../../services/AccountService';
import { ServerResponse } from '../../../services/server/OldWebClient';
import DownGradeImage from '../../../resources/downgrade-guy.png';
import PriceTagIcon from '@material-ui/icons/LocalOffer';
import ClockIcon from '@material-ui/icons/Schedule';
import { EventTracking } from '../../../utilities/Tracking/EventTracking';
import { useIsMobile } from '../../../components/Mui3WidthProvider';

const useStyles = makeStyles((theme) => ({
    headerWrapper: {
        backgroundColor: '#2196F3',
    },
    header: {
        color: '#fff', 
        fontWeight: 500
    }, 
    banner: {
        fontWeight: 500,
        paddingBottom: 10,
        paddingTop: 10,
    },
    paper: {
        backgroundColor: "#f1f1f1"
    },
    imageWrapper: {
        textAlign: "center",
        [theme.breakpoints.down('sm')]: {
            height: 128,
            width: 128
        },
        [theme.breakpoints.down('xs')]: {
            display: "none"
        },
    },
    downGradeImage: {
        width: 255,
        [theme.breakpoints.down('sm')]: {
            height: 128,
            width: 128
        }
    },
    iconWrapper: {
        height: 128,
        width: 128,
    },
    icon: {
        margin: 'auto',
        display: 'block',
        width: '80%',
        height: '103%',
        transform: "scaleX(-1)",
        color: '#b8b8b8',
    },
    cancelButton: {
        color: '#6c757d',
        borderColor: '#6c757d',
        float: 'right',
        width: 235,
        "&:hover": {
            backgroundColor: "#6c757d",
            color: "#fff"
        },
    },
    downGradeButton: {
        width: 235,
    },
    cardTitle: {
        fontWeight: 500
    },
    textCard: {
        paddingRight: 0, 
        paddingLeft: 0, 
        paddingBottom: 0,
        [theme.breakpoints.down('sm')]: {
            padding: 10,
        }
    }
}));

interface Props {
    openSpecialOfferDialog: boolean;
    toggleSpecialOfferDialog: () => void;
    onSubscriptionChanged: (updatedUser:ApplicationUser) => void;
    toggleConfirmationDialog: () => void;
    toggleShowErrorMessage: () => void;
    setErrorMessage: (message:string) => void;
}

export function SpecialOfferDialog(props:Props) {
    const { openSpecialOfferDialog, toggleSpecialOfferDialog, onSubscriptionChanged, toggleConfirmationDialog, toggleShowErrorMessage, setErrorMessage} = props;
    const isMobile = useIsMobile();
    const classes = useStyles();

    const [disabled, setdisabled] = useState<boolean>(false);

    const onDiscountSubscription = async() => {
        setdisabled(true)

        let applicationUserResponse = await AccountService.discountMakerSubscription();
        if (ServerResponse.isSuccess(applicationUserResponse)) {
            onSubscriptionChanged(applicationUserResponse.data);
            EventTracking.Subscribe.onDiscountPlan();
        } else if(ServerResponse.isError(applicationUserResponse)){
            setErrorMessage(applicationUserResponse.message)
            toggleShowErrorMessage();
        }     
        setdisabled(false);
        toggleSpecialOfferDialog()
        toggleConfirmationDialog()
    }

    const onContinueCancel = async() => {
        setdisabled(true);

        let applicationUserResponse = await AccountService.cancelMakerSubscriptionAtEndOfTerm();
        if (ServerResponse.isSuccess(applicationUserResponse)) {
            onSubscriptionChanged(applicationUserResponse.data);
            EventTracking.Subscribe.onCancelSubscription();
        } else if(ServerResponse.isError(applicationUserResponse)){
            setErrorMessage(applicationUserResponse.message)
            toggleShowErrorMessage();
        }        
        setdisabled(false);
        toggleSpecialOfferDialog()
    }

    return (
        <Dialog open={openSpecialOfferDialog} onClose={toggleSpecialOfferDialog} maxWidth="md" disableEscapeKeyDown disableBackdropClick>
        <DialogTitle className={classes.headerWrapper} disableTypography >
            <Typography variant="h5" className={classes.header} >Wait, before you cancel...</Typography>
        </DialogTitle>
        <DialogContent>
            <Typography variant='h5' className={classes.banner}>SPECIAL OFFER FOR YOU</Typography>
            <Grid container spacing={3} justifyContent='center' alignItems='center'>
                <Grid item md={isMobile ? 6 : 12} style={{width: '100%'}}>
                    <Grid container direction="row" justifyContent='center' alignItems='center' className={classes.paper}>
                        <Grid item md={!isMobile} className={classes.imageWrapper}>
                            <img src={DownGradeImage} alt="Downgrade" className={classes.downGradeImage}/>
                        </Grid>
                        <Hidden mdUp >
                            <Grid item sm>
                                <CardContent className={classes.textCard}>
                                    <Typography gutterBottom className={classes.cardTitle} variant='h5' color='primary'>Keep Everything… for only $149 a year</Typography>
                                    <Typography variant="subtitle2"> 
                                        Keep all your Sermon Maker benefits, plus get upcoming software updates
                                    </Typography>
                                </CardContent>
                            </Grid>
                        </Hidden>
                        <Hidden smDown>
                            <Grid item md={6}>
                                <Typography gutterBottom variant='h5' color='primary' className={classes.cardTitle} style={{marginLeft: '-5rem'}}>Keep Everything… </Typography>
                                <Typography gutterBottom variant="h5" style={{marginLeft: '-4rem', fontWeight: 500}}>for only $149 a year</Typography>
                                <Typography variant="subtitle2" style={{marginLeft: '-4.5rem'}}>
                                    Keep all your Sermon Maker benefits, 
                                </Typography>
                                <Typography variant="subtitle2" style={{marginLeft: '-3.5rem'}}>
                                    plus get upcoming software updates
                                </Typography>
                            </Grid>
                        </Hidden>
                    </Grid>
                </Grid>
                <Grid item md={6} style={{width: '100%'}}>
                    <Grid container direction="row" justifyContent='center' alignItems='center' className={classes.paper}>
                        {!isMobile && 
                            <Grid item className={classes.iconWrapper} style={{textAlign: "right"}}>
                                <PriceTagIcon className={classes.icon}/>
                            </Grid>
                        }
                        <Grid item sm style={{height: 128}}>
                            <CardContent className={classes.textCard}>
                                <Typography gutterBottom className={classes.cardTitle} variant='h5' color='primary'>New Annual Fee</Typography>
                                <Typography variant="subtitle2">
                                    Your new Sermon Maker price is only $149 per year. Get everything for less than $2.87 a week!
                                </Typography>
                            </CardContent>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} style={{width: '100%'}}>
                    <Grid container direction="row" justifyContent='center' alignItems='center' className={classes.paper}>
                        {!isMobile && 
                            <Grid item className={classes.iconWrapper}>
                                <ClockIcon className={classes.icon}/>
                            </Grid>
                        }
                        <Grid item sm style={{height: 128}}>
                            <CardContent className={classes.textCard}>
                                <Typography gutterBottom className={classes.cardTitle} variant='h5' color='primary'>One-Time Offer</Typography>
                                <Typography variant="subtitle2">
                                    This special $149 price is an exclusive offer only available today. Don’t miss your chance to save!
                                </Typography>
                            </CardContent>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={isMobile ? 1 : 2} justifyContent='center' alignItems='center' direction={isMobile ? "column-reverse" : "row"}>
                    <Grid item md={isMobile ? 6 : 3}>
                        <Button 
                            variant='outlined' 
                            disabled={disabled} 
                            className={classes.cancelButton} 
                            size="medium" 
                            onClick={onContinueCancel}>
                                Continue Canceling
                            </Button>
                    </Grid>
                    <Grid item md={isMobile ? 6 : 3}>
                        <Button 
                            variant='contained' 
                            disabled={disabled} 
                            className={classes.downGradeButton}  
                            size="medium" 
                            color="primary" 
                            onClick={onDiscountSubscription}>
                                Yes, I want this offer!
                        </Button>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography color="textSecondary">
                    Grab this offer to <strong>keep your account active for less than $12.50 per month</strong> (paid annually). All your sermons and resources will remain safe with continued access to all Sermon Maker benefits. Plus, you'll get upcoming software updates on Sermon Maker so you can stay organized, with 100% access to premium sermon ideas and time-saving features.
                    </Typography>
                </Grid>
            </Grid>
        </DialogContent>
    </Dialog>
    );
}